export const MATCH_MODEL = "match";

const matchModel = {
  status: "",
  date: "",
  booking: {
    jsonApi: "hasOne",
    type: "bookings"
  },
  user: {
    jsonApi: "hasOne",
    type: "users"
  }
};

export default matchModel;
